import { all, call, put, takeLatest } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"
import { get, isEmpty } from "lodash"

import {
  CREATE_SURVEY_WATCHER,
  GET_SURVEYS,
  GET_SURVEY_WATCHER,
  GET_SURVEYS_TEMPLATE_WATCHER,
  DUPLICATE_SURVEY_WATCHER,
  DELETE_SURVEY_WATCHER,
  GET_SURVEY_ENPS_WATCHER,
  GET_SURVEY_QUALITATIVE_WATCHER,
  DOWNLOAD_SURVEYS_WATCHER,
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SCOPE_TYPES_WATCHER,
  GET_SURVEYS_BY_INDICATORS_WATCHER,
} from "./constants"

import {
  getSurveys,
  deleteSurveyFailed,
  getSurveysSuccess,
  getSurveySuccess,
  getSurveyFailed,
  getSurveysTemplateSuccess,
  getSurveysTemplateFailed,
  duplicateSurveyFailed,
  getSurveyQualitativeSuccess,
  getSurveyQualitativeFailed,
  getSurveyEnpsSuccess,
  getSurveyEnpsFailed,
  getSurveysFailed,
  createSurveyFailed,
  getSegmentsSuccess,
  getSegmentsFailed,
  getSurveyTypesFailed,
  getSurveyTypesSuccess,
  getScopeTypesFailed,
  getScopeTypesSuccess,
  getSurveysByIndicatorsSuccess,
  getSurveysByIndicatorsFailed,
  getSurveysByIndicatorsWatcher,
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"
import {
  getScopeTypesApi,
  getSegmentsApi,
  getSurveyTypesApi,
  getSurveyTypesCreateApi,
} from "../../utils/routes/routes-survey"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

function getSurveysApi(id) {
  return axios.request({
    method: "GET",
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/surveys`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: { "filter[filterBySurveyType]": id },
  })
}

function getSurveysByIndicatorsApi() {
  return axios.request({
    method: "GET",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys/indicators`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

function getSurveysCountApi(id) {
  return axios.request({
    method: "GET",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys/count/questions`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: { "filter[filterBySurveyType]": id },
  })
}
function getSurveysDeletableApi() {
  return axios.request({
    method: "GET",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys/deletable`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

export function* getSurveysByIndicatorsSaga() {
  try {
    const [surveysByIndicators, isDeletableBox, questionsCount] = yield all([
      call(getSurveysByIndicatorsApi),
      call(getSurveysDeletableApi),
      call(getSurveysCountApi),
    ])
    const { data } = surveysByIndicators
    const newData = data.map((x) => {
      let surveys = x.surveys.map((y) => {
        const { questions } = questionsCount.data.data.find(
          (climate) => y.id_survey === climate.id_survey
        ) || { questions: 0 }

        const objectDeletable = isDeletableBox.data.data.find(
          (deletable) => y.id_survey === deletable.id_survey
        )
        let is_deletable = false

        if (objectDeletable) {
          is_deletable = objectDeletable.deletable
        }

        return { ...y, is_deletable, questions }
      })
      return { ...x, surveys }
    })
    if (surveysByIndicators.status === 200) {
      yield put(getSurveysByIndicatorsSuccess(newData))
    }
  } catch (e) {
    yield put(getSurveysByIndicatorsFailed())
    returnMessage(e)
  }
}

export function* getSurveysSaga() {
  try {
    const [
      climate,
      leadership,
      climateCount,
      leadershipCount,
      isDeletableBox,
    ] = yield all([
      call(getSurveysApi, 1),
      call(getSurveysApi, 2),
      call(getSurveysCountApi, 1),
      call(getSurveysCountApi, 2),
      call(getSurveysDeletableApi),
    ])

    const surveys = {
      climate: climate.data.data.map((item) => {
        const { questions } = climateCount.data.data.find(
          (climate) => item.id_survey === climate.id_survey
        ) || { questions: 0 }
        const is_deletable = isDeletableBox.data.data.find(
          (deletable) => item.id_survey === deletable.id_survey
        ).deletable
        return { ...item, questions, is_deletable }
      }),
      leadership: leadership.data.data.map((item) => {
        const { questions } = leadershipCount.data.data.find(
          (leadership) => item.id_survey === leadership.id_survey
        ) || { questions: 0 }
        const is_deletable = isDeletableBox.data.data.find(
          (deletable) => item.id_survey === deletable.id_survey
        ).deletable
        return { ...item, questions, is_deletable }
      }),
    }
    yield put(getSurveysSuccess(surveys))
  } catch (e) {
    yield put(getSurveysFailed())
  }
}

export function* getSegmentsSaga() {
  try {
    const { data, status } = yield call(getSegmentsApi)
    if (status === 200) {
      yield put(getSegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getSegmentsFailed())
    returnMessage(error)
  }
}

export function* getSurveyTypesSaga() {
  try {
    const { data, status } = yield call(getSurveyTypesCreateApi)
    if (status === 200) {
      yield put(getSurveyTypesSuccess(data))
    }
  } catch (error) {
    yield put(getSurveyTypesFailed())
    returnMessage(error)
  }
}

export function* getScopeTypesSaga() {
  try {
    const { data, status } = yield call(getScopeTypesApi)
    if (status === 200) {
      yield put(getScopeTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getScopeTypesFailed())
    returnMessage(error)
  }
}

function createSurveyApi(data = {}) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys`,
    data,
  })
}

export function* createSurveySaga(action) {
  try {
    const data = yield call(createSurveyApi, action.payload)
    yield put(push(`/models/surveys/${data.data.data.survey.id_survey}`))
  } catch (error) {
    yield put(createSurveyFailed())
    returnMessage(error)
  }
}

// GET SURVEY ENPS
export function getSurveyEnpsWatcherApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions/enps`,
  })
}

// export function* getSurveyEnpsWatcherSaga(action) {
//   try {
//     const { status, data } = yield call(getSurveyEnpsWatcherApi, action.payload);

//     if (status === 200) {
//       yield put(getSurveyEnpsSuccess(data))
//     }
//   } catch (error) {
//     yield put(getSurveyEnpsFailed())
//   }
// }

// GET SURVEY WATCHER
export function getSurveyWatcherApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }surveys/${idSurvey}/summary?id_company=${LOCAL_COMPANY_ID()}`,
  })
}

export function* getSurveyWatcherSaga(action) {
  try {
    const [{ status, data }, questionEnps] = yield all([
      call(getSurveyWatcherApi, action.payload),
      call(getSurveyEnpsWatcherApi, action.payload),
    ])

    let dataEnps = questionEnps.data
    let engagementContent = get(data, "data.engagement[0]", {})
    const enpsTrueEngagement = get(questionEnps, "data.data[0]", {})

    if (enpsTrueEngagement.engagement) {
      dataEnps = {}
      engagementContent = {
        ...engagementContent,
        subdimensions: [
          ...engagementContent.subdimensions,
          {
            dimension_name: "eNPS (Employee Net Promoter Score)",
            dimension_title: "eNPS (Employee Net Promoter Score)",
            subdimensions: [],
            questions: [
              {
                question_enabled: enpsTrueEngagement.enabled,
                question_generic: enpsTrueEngagement.generic,
                question_id_question: enpsTrueEngagement.id_question,
                question_id_question_has_dimensions:
                  enpsTrueEngagement.id_question_has_dimension,
                question_id_question_type: enpsTrueEngagement.id_question_type,
                question_name: enpsTrueEngagement.name,
                required: enpsTrueEngagement.required
              },
            ],
          },
        ],
      }
    }

    const dataParsed = {
      summary: isEmpty(engagementContent)
        ? data.data.summary
        : [...data.data.summary, engagementContent],
      survey: data.data.survey,
    }

    if (status === 200) {
      yield put(getSurveySuccess(dataParsed))
      yield put(getSurveyEnpsSuccess(dataEnps))
    }
  } catch (error) {
    yield put(getSurveyFailed())
  }
}

// GET SURVEYS TEMPLATE WATCHER
export function getSurveysTemplateWatcherApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys/templates`,
  })
}

export function getSurveysTemplateCountWatcherApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/surveys/templates/count/questions`,
  })
}

export function* getSurveysTemplateWatcherSaga() {
  try {
    const [suveysTemplate, suveysTemplateCount] = yield all([
      call(getSurveysTemplateWatcherApi),
      call(getSurveysTemplateCountWatcherApi),
    ])

    const data = suveysTemplate.data.data.map((item) => {
      return {
        ...item,
        questions: suveysTemplateCount.data.data.find(
          (question) => item.id_survey === question.id_survey
        ),
      }
    })

    yield put(getSurveysTemplateSuccess(data))
  } catch (error) {
    yield put(getSurveysTemplateFailed())
  }
}

// DUPLICATE SURVEY
// preguntar
export function duplicateSurveyApi(model) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${
      model.id_survey
    }/duplicate?id_company=${LOCAL_COMPANY_ID()}`,
    data: model,
  })
}

export function* duplicateSurveySaga(action) {
  try {
    const { status, data } = yield call(duplicateSurveyApi, action.payload)

    if (status === 201) {
      // yield put(getSurveys());
      // Redireccionar
      yield call(messageSuccess, data.data.msj)
      yield put(push(`/models/surveys/${data.data.survey.id_survey}`))
    }
  } catch (error) {
    yield put(duplicateSurveyFailed())
    returnMessage(error)
  }
}

// DELETE SURVEY
export function deleteSurveyApi(idSurvey) {
  return axios.request({
    method: "delete",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}`,
  })
}

export function* deleteSurveySaga(action) {
  try {
    const { status, data } = yield call(deleteSurveyApi, action.payload)
    if (status === 200) {
      yield call(messageSuccess, data.data.msj)
      yield put(getSurveys())
      yield put(getSurveysByIndicatorsWatcher())
    }
  } catch (error) {
    returnMessage(error)
    yield put(deleteSurveyFailed())
  }
}

// GET SURVEY QUALITATIVE
export function getSurveyQualitativeApi(idSurvey) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveys/${idSurvey}/questions/qualitative`,
  })
}
export function* getSurveyQualitativeSaga(action) {
  try {
    const { data, status } = yield call(getSurveyQualitativeApi, action.payload)

    if (status === 200) {
      yield put(getSurveyQualitativeSuccess(data))
    }
  } catch (error) {
    yield put(getSurveyQualitativeFailed())
  }
}

/* DOWNLOAD */
function getSurveyExcelApi(idSurvey) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/${idSurvey}/export/xlsx/download`,
  })
}

function getSurveyExcelProgress() {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/survey/export/xlsx/progress`,
  })
}

function downloadSurveyUrl(url) {
  location.replace(url)
}

export function* downloadSurveySaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getSurveyExcelApi, action.payload)
    let data

    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getSurveyExcelProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo descargado")
    yield call(downloadSurveyUrl, data.data[0].url)
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar archivo")
  }
}

// Individual exports for testing
export default function* surveysSaga() {
  yield takeLatest(CREATE_SURVEY_WATCHER, createSurveySaga)
  yield takeLatest(DELETE_SURVEY_WATCHER, deleteSurveySaga)
  yield takeLatest(GET_SURVEY_WATCHER, getSurveyWatcherSaga)
  yield takeLatest(GET_SURVEYS_TEMPLATE_WATCHER, getSurveysTemplateWatcherSaga)
  yield takeLatest(DUPLICATE_SURVEY_WATCHER, duplicateSurveySaga)
  // yield takeLatest(GET_SURVEY_ENPS_WATCHER, getSurveyEnpsWatcherSaga);
  yield takeLatest(GET_SURVEY_QUALITATIVE_WATCHER, getSurveyQualitativeSaga)
  yield takeLatest(DOWNLOAD_SURVEYS_WATCHER, downloadSurveySaga)
  yield takeLatest(GET_SEGMENTS_WATCHER, getSegmentsSaga)
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_SCOPE_TYPES_WATCHER, getScopeTypesSaga)
  yield takeLatest(
    GET_SURVEYS_BY_INDICATORS_WATCHER,
    getSurveysByIndicatorsSaga
  )
}
